export function earlyAdvanceWentRegularPath(op: any): boolean {
  const cavali = op?.checklist?.find((c: any) => c.type === 'cavali');
  const pct = Number(String(cavali?.percentage ?? '').replace('%', '').trim());
  const cavaliFull = pct === 100;
  const approved = op?.earlyAdvanceRequest?.status === 'approved';
  
  return cavaliFull && approved;
}
